module.exports = __webpack_public_path__ + "img/25ba5ace77530d1a0befabe159a935a.9633bdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/25ba5ace77530d1a0befabe159a935a.png
// module id = 0eOF
// module chunks = 1